import { render, staticRenderFns } from "./vessel-workspace.vue?vue&type=template&id=47c769ee&scoped=true"
import script from "./vessel-workspace.vue?vue&type=script&lang=js"
export * from "./vessel-workspace.vue?vue&type=script&lang=js"
import style0 from "./vessel-workspace.vue?vue&type=style&index=0&id=47c769ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c769ee",
  null
  
)

export default component.exports